export default __webpack_public_path__ + "static/Major-Expenses-Remote-Workers-Internet-06951c08f6f330dcfc20adc66823b41a.jpg";